import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  caperAccessControl,
  shelfLabelsAccessControl,
  uposStatusAccessControl,
  uposRetailerAccessControl,
  uposStoreAccessControl,
  unifiedBarcodesAccessControl,
  notOnFileAccessControl,
  paymentTerminalsAccessControl,
} from '../access-control/connectedStoresAccess.configuration'
import Toasts from '../toasts'

// Caper
const ConnectedStoresAdminCaperHomePage = lazy(
  () => import('../pages/caper/ConnectedStoresAdminCaperHomePage')
)
const ConnectedStoresAdminCaperSessionReplayPage = lazy(
  () => import('../pages/caper/ConnectedStoresAdminCaperSessionReplayPage')
)
const ConnectedStoresAdminCaperConfigPage = lazy(
  () => import('../pages/caper/ConnectedStoresAdminCaperConfigPage')
)
const ConnectedStoresAdminCaperConfigKeyPage = lazy(
  () => import('../pages/caper/ConnectedStoresAdminCaperConfigKeysPage')
)
const ConnectedStoresAdminCaperCreateEntityPage = lazy(
  () => import('../pages/caper/ConnectedStoresAdminCaperCreateEntityPage')
)
const ConnectedStoresAdminCaperFeaturesPage = lazy(
  () => import('../pages/caper/ConnectedStoresAdminCaperFeaturesPage')
)
const ConnectedStoresAdminCaperBanListPage = lazy(
  () => import('../pages/caper/ConnectedStoresAdminCaperBanListPage')
)

// Payment Terminals
const ConnectedStoresAdminPaymentTerminalsPage = lazy(
  () => import('../pages/payment-terminals/ConnectedStoresAdminPaymentTerminalsPage')
)
const ConnectedStoresAdminPaymentTerminalsDetailsPage = lazy(
  () => import('../pages/payment-terminals/ConnectedStoresAdminPaymentTerminalsDetailsPage')
)

// Upos
const ConnectedStoresAdminUposStatusPage = lazy(() => import('../pages/upos/status'))
const ConnectedStoresAdminUposRetailersPage = lazy(() => import('../pages/upos/retailers'))
const ConnectedStoresAdminUposProfilesPage = lazy(() => import('../pages/upos/profiles'))
const ConnectedStoresAdminUposStoresPage = lazy(() => import('../pages/upos/stores'))
const ConnectedStoresAdminUposIntegrationsPage = lazy(() => import('../pages/upos/integrations'))

// Unified Barcodes
const ConnectedStoresAdminUnifiedBarcodesPage = lazy(() => import('../pages/unified-barcodes'))

// Shelf Labels
const ConnectedStoresAdminShelfLabelsStorePage = lazy(() => import('../pages/shelf-labels/store'))
const ConnectedStoresAdminShelfLabelsConnectionPage = lazy(
  () => import('../pages/shelf-labels/connection')
)
const ConnectedStoresAdminShelfLabelsSyncStrategyPage = lazy(
  () => import('../pages/shelf-labels/syncStrategy')
)
const ConnectedStoresAdminShelfLabelsAutomationPage = lazy(
  () => import('../pages/shelf-labels/automation')
)
// @hygen:inject../pages/shelf-labels

// Not on File
const ConnectedStoresNotOnFilePage = lazy(() => import('../pages/not-on-file'))
const ConnectedStoresNotOnFileDetailsPage = lazy(() => import('../pages/not-on-file/details'))

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
// All the @ts-ignore are because DomainRoute is not smart enough to know about
// the params.
export const connectedStoresAdminRouter = (
  <DomainRoute route="app-admin-connected-stores">
    <Toasts />
    <DashSwitch>
      {/* Caper */}
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper"
        tool="caper-dashboard-tool"
        component={ConnectedStoresAdminCaperHomePage}
        accessControl={caperAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-session-replay"
        tool="caper-dashboard-tool"
        component={ConnectedStoresAdminCaperSessionReplayPage}
        accessControl={caperAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-config"
        tool="caper-dashboard-tool"
        // @ts-ignore
        component={ConnectedStoresAdminCaperConfigPage}
        accessControl={caperAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-config-keys"
        tool="caper-dashboard-tool"
        component={ConnectedStoresAdminCaperConfigKeyPage}
        accessControl={caperAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-config-create"
        tool="caper-dashboard-tool"
        // @ts-ignore
        component={ConnectedStoresAdminCaperCreateEntityPage}
        accessControl={caperAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-config-partner"
        tool="caper-dashboard-tool"
        // @ts-ignore
        component={ConnectedStoresAdminCaperConfigPage}
        accessControl={caperAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-config-retailer"
        tool="caper-dashboard-tool"
        // @ts-ignore
        component={ConnectedStoresAdminCaperConfigPage}
        accessControl={caperAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-config-store"
        tool="caper-dashboard-tool"
        // @ts-ignore
        component={ConnectedStoresAdminCaperConfigPage}
        accessControl={caperAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-config-device"
        tool="caper-dashboard-tool"
        // @ts-ignore
        component={ConnectedStoresAdminCaperConfigPage}
        accessControl={caperAccessControl}
      />
      {/* Upos */}
      <DomainRoute
        exact
        route="app-admin-connected-stores-upos-status"
        // @ts-ignore
        component={ConnectedStoresAdminUposStatusPage}
        accessControl={uposStatusAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-upos-retailers"
        // @ts-ignore
        component={ConnectedStoresAdminUposRetailersPage}
        accessControl={uposRetailerAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-upos-profiles"
        // @ts-ignore
        component={ConnectedStoresAdminUposProfilesPage}
        accessControl={uposRetailerAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-upos-stores"
        // @ts-ignore
        component={ConnectedStoresAdminUposStoresPage}
        accessControl={uposStoreAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-upos-integrations"
        // @ts-ignore
        component={ConnectedStoresAdminUposIntegrationsPage}
        accessControl={uposStoreAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-unified-barcodes"
        // @ts-ignore
        component={ConnectedStoresAdminUnifiedBarcodesPage}
        accessControl={unifiedBarcodesAccessControl}
      />
      {/* Shelf Labels */}
      <DomainRoute
        exact
        route="app-admin-connected-stores-shelf-labels-stores"
        // @ts-ignore
        component={ConnectedStoresAdminShelfLabelsStorePage}
        accessControl={shelfLabelsAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-shelf-labels-connections"
        // @ts-ignore
        component={ConnectedStoresAdminShelfLabelsConnectionPage}
        accessControl={shelfLabelsAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-shelf-labels-sync-strategies"
        // @ts-ignore
        component={ConnectedStoresAdminShelfLabelsSyncStrategyPage}
        accessControl={shelfLabelsAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-shelf-labels-automations"
        // @ts-ignore
        component={ConnectedStoresAdminShelfLabelsAutomationPage}
        accessControl={shelfLabelsAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-features"
        tool="caper-dashboard-tool"
        component={ConnectedStoresAdminCaperFeaturesPage}
        accessControl={caperAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-ban-list"
        tool="caper-dashboard-tool"
        component={ConnectedStoresAdminCaperBanListPage}
        accessControl={caperAccessControl}
      />
      {/* Payment Terminals */}
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-payment-terminals"
        tool="caper-dashboard-tool"
        // @ts-ignore
        component={ConnectedStoresAdminPaymentTerminalsPage}
        accessControl={paymentTerminalsAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-caper-payment-terminals-details"
        tool="caper-dashboard-tool"
        // @ts-ignore
        component={ConnectedStoresAdminPaymentTerminalsDetailsPage}
        accessControl={paymentTerminalsAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-not-on-file"
        // @ts-ignore
        component={ConnectedStoresNotOnFilePage}
        accessControl={notOnFileAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-connected-stores-not-on-file-details"
        // @ts-ignore
        component={ConnectedStoresNotOnFileDetailsPage}
        accessControl={notOnFileAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
